'use strict';
class MeasureModal extends HTMLElement {
  constructor() {
    super()
    this.container = this.querySelector('.measure-modal__container')
    this.closeBtn = this.querySelector('.measure-modal__close')
    this.overlay = this.querySelector('.measure-modal__overlay')
    this.opener = null

    // Delegated so triggers rendered after load (e.g. quick add) also work
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('.show_measure_modal')
      if (opener) this.openModal(opener)
    })

    this.closeBtn.addEventListener('click', this.closeModal.bind(this))
    this.overlay.addEventListener('click', this.closeModal.bind(this))
    // keyup, not keydown: Dawn modals close on keyup, so closing earlier would move
    // focus back into a quick add modal and close it with the same key press
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && !this.classList.contains('hidden')) {
        this.closeModal();
      }
    });
  }

  openModal(opener) {
    this.opener = opener
    this.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
    trapFocus(this.container, this.closeBtn)
  }

  closeModal() {
    if (this.classList.contains('hidden')) return
    this.classList.add('hidden')

    // Opened from inside another modal (quick add): keep its scroll lock and focus trap
    const parentModal = this.opener?.closest('modal-dialog[open], quick-add-modal[open]')
    if (parentModal) {
      trapFocus(parentModal, this.opener)
    } else {
      document.body.classList.remove('overflow-hidden')
      removeTrapFocus(this.opener)
    }
    this.opener = null
  }
}

customElements.define('measure-modal', MeasureModal)
// End measure modal

const header = document.querySelector("sticky-header");
const firstSection = document.querySelector("main section:first-child");
const white_logo = document.querySelector(".logo_white");
const black_logo = document.querySelector(".logo_black");

if (firstSection.classList.contains("transparent_header")) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          header.classList.add("opaque");

        } else {
          header.classList.remove("opaque");

        }
      });
    },
    { threshold: 0.1 }
  );

  observer.observe(firstSection);
} else {

  header.classList.add("always_opaque");

}
function copyToClipboard(textToCopy, linkElement) {
  console.log("___________________________test")
  navigator.clipboard.writeText(textToCopy);

  const tooltip = document.createElement("span");
  tooltip.className = "tooltiptext";
  tooltip.innerHTML = "Copied: " + textToCopy;
  document.querySelector("#MainContent").appendChild(tooltip);

  // Get link position
  const rect = linkElement.getBoundingClientRect();
  tooltip.style.top = (window.scrollY + rect.bottom + 4) + "px"; // 4px gap under link
  tooltip.style.left = (window.scrollX + rect.left) + "px"; // align with link start


  // Hide again after 2 seconds
  setTimeout(function () {
    tooltip.classList.add("hidden");
    tooltip.innerHTML = "";
    tooltip.remove();
  }, 4000);
}


document.addEventListener("DOMContentLoaded", () => {
  // Consider mobile if width <= 1024px (adjust threshold if needed)
  const isMobile = window.innerWidth <= 749;

  if (!isMobile) {
    // Desktop: override tel: and mailto: links
    document.querySelectorAll('a[href^="tel:"], a[href^="mailto:"]').forEach(link => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const textToCopy = link.getAttribute("href").replace(/^(tel:|mailto:)/, "");
        copyToClipboard(textToCopy, link);
      });
    });
  }
});